import React from 'react';
import { ExperiencePricingSchema } from './schema';
import ExperienceCharges from '../../Fees/ExperienceCharges';
import { useFormState } from '../useFormState';
import RatesCalendar from '../../Owner/RatesCalendar';
import NetEarnings from '../../Fees/NetEarnings';
import { Stack, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { z } from 'zod';

const ExperiencePricingForm = () => {
    const { control } =
        useFormContext<z.infer<typeof ExperiencePricingSchema>>();
    const { experience, workflow } = useFormState();

    const charges = useWatch({ name: 'charges', control });
    const prices = charges.filter(
        (charge: { chargeType: string }) =>
            charge.chargeType === 'price' ||
            charge.chargeType === 'flexiblePrice',
    );

    return (
        <Stack spacing={2}>
            <div>
                <Typography variant='h2'>Pricing</Typography>
                <Typography sx={{ color: 'text.secondary' }} gutterBottom>
                    Set your experience's pricing and fees. You can always edit
                    this later.
                </Typography>
            </div>
            <ExperienceCharges
                experienceType={experience.type}
                isEditing={workflow === 'edit'}
            />
            {prices.length > 0 && <RatesCalendar />}
            <NetEarnings />
        </Stack>
    );
};

const ExperiencePricing = () => {
    return <ExperiencePricingForm />;
};

export default ExperiencePricing;
